import React, {Component} from 'react'
import {
  Box,
  Button,
  Heading,
  Text,
  VStack,
  Grid,
  GridItem,
  Textarea,
  Input,
  FormControl,
  FormLabel
} from '@chakra-ui/react';
import './BerichtSturen.css'
import Sidebar from '../Sidebar/Sidebar';
import Navigation from '../../Navigation/Navigation';
import MobileMenu from '../MobileMenu/MobileMenu';
import Footer from '../../../components/Footer/Footer';
import colors from '../../../theme/colors';

class BerichtSturen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobileMenuOpen: false
    };
  }

  handleOpenMobileMenu = () => {
    this.setState({ isMobileMenuOpen: true })
  }

  handleCloseMobileMenu = () => {
    this.setState({ isMobileMenuOpen: false })
  }

  componentWillUnmount() {
    // Ensure mobile menu is closed when component unmounts
    if (this.state.isMobileMenuOpen) {
      this.setState({ isMobileMenuOpen: false })
    }
  }
  render () {
    return (
      <>
        <Grid
        templateColumns="repeat(24, 1fr)"
        gap={0}
        minH="100vh"
        bg="gray.50"
        >
        <GridItem
        as="aside"
        colSpan={{ base: 0, md: 4, lg: 3 }} 
          display={{ base: "none", md: "block" }}
        bg="white"
        borderRight="1px solid"
        borderColor="gray.200"
        >
        <Sidebar
        state = {this.props.state}
        onRouteChange = {this.props.onRouteChange}
        onLogout = {this.props.onLogout}
        />

        </GridItem>
        <GridItem
        as="main"
        colSpan={{ base: 24, md: 20, lg: 21 }}
        p="10px"
        display="flex"
        flexDirection="column"
        minHeight="100vh"
        >
        <Navigation
        state = {this.props.state}
        onRouteChange = {this.props.onRouteChange}
        getFeed = {this.props.getFeed}
        onVersionChange = {this.props.onVersionChange}
        onLogout = {this.props.onLogout}
        onOpenFeedback = {this.props.onOpenFeedback}
        onOpenMobileMenu = {this.handleOpenMobileMenu}
        />

        <Box p="40px" flex="1" display="flex" justifyContent="center" alignItems="center">
          <Box maxW="800px" w="100%">
            <VStack spacing={6} align="stretch">
              <Heading as="h2" size="lg" textAlign="center" color="gray.600">
                Bericht Sturen
              </Heading>
              
              <Text color="gray.500" textAlign="center">
                Stuur een bericht naar een burger
              </Text>
              
              <FormControl isRequired>
                <FormLabel>Ontvanger</FormLabel>
                <Input
                  placeholder="Gebruikersnaam van de ontvanger"
                  value={this.props.state.messageRecipient || ''}
                  isReadOnly
                  bg="gray.100"
                  border="2px solid"
                  borderColor="gray.200"
                  cursor="not-allowed"
                  _focus={{
                    borderColor: "gray.200"
                  }}
                />
              </FormControl>
              
              <FormControl isRequired>
                <FormLabel>Onderwerp</FormLabel>
                <Input
                  placeholder="Onderwerp van het bericht"
                  value={this.props.state.messageSubject || ''}
                  onChange={(e) => this.props.onMessageFieldChange('messageSubject', e.target.value)}
                  bg="white"
                  border="2px solid"
                  borderColor="gray.200"
                  _focus={{
                    borderColor: "blue.400"
                  }}
                />
              </FormControl>
              
              <FormControl isRequired>
                <FormLabel>Bericht</FormLabel>
                <Textarea
                  placeholder="Typ hier uw bericht..."
                  size="lg"
                  minH="300px"
                  resize="vertical"
                  value={this.props.state.messageText || ''}
                  onChange={(e) => this.props.onMessageFieldChange('messageText', e.target.value)}
                  bg="white"
                  border="2px solid"
                  borderColor="gray.200"
                  _focus={{
                    borderColor: "blue.400"
                  }}
                />
              </FormControl>
              
              <Box textAlign="right">
                <Button
                  bg={colors.primary.main}
                  color="white"
                  _hover={{ bg: colors.primary.dark }}
                  size="lg"
                  onClick={this.props.onSendMessage}
                  px={8}
                >
                  Bericht Verzenden
                </Button>
              </Box>
            </VStack>
          </Box>
        </Box>
        <Footer onRouteChange={this.props.onRouteChange} />

        </GridItem>
        </Grid>
      
        {/* Mobile Menu Drawer */}
        <MobileMenu
          isOpen={this.state.isMobileMenuOpen}
          onClose={this.handleCloseMobileMenu}
          onRouteChange={this.props.onRouteChange}
          userVersion={this.props.state.userVersion}
          resetSuggestionsPage={this.props.resetSuggestionsPage}
          onLogout={this.props.onLogout}
        />
      </>
    )
  }
}

export default BerichtSturen
